import Vue from 'vue'
import Vuex from 'vuex'

import Authentication from './authentication'
import Qs from 'qs'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    token: null,
    expirationDate: null,
    error: null
  },
  getters: {
    getToken: state => state.token,
    getExpirationDate: state => state.expirationDate
  },
  mutations: {
    storeToken (state, payload) {
      state.token = payload
    },
    storeExpirationDate (state, payload) {
      state.expirationDate = payload
    },
    storeError (state, payload) {
      state.error = payload
    },
    reset: state => {
      state.token = null
      state.expirationDate = null
      state.error = null
    }
  },
  actions: {
    getToken ({ commit }) {
      const token = this.state.token
      let expirationDate = new Date(this.state.expirationDate)
      if (token && expirationDate) {
        if (expirationDate >= new Date()) {
          return
        }
      }
      const authData = Qs.stringify({
        Username: 'advensys',
        Password: 'ad26',
        grant_type: 'password',
        client_id: 'web.api',
        client_secret: 'web.api.secret'
      })
      return Authentication.post('/token', authData).then(response => {
        const now = new Date()
        expirationDate = new Date(now.getTime() + response.data.expires_in * 1000)
        commit('storeToken', response.data.access_token)
        commit('storeExpirationDate', expirationDate)
      }).catch(error => {
        console.log('GetToken Error : ', error)
        throw error
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js